import axios from "axios";
import React from "react";

interface ISpecialty {
  id: number;
  name: string;
}

export default function useSpecialties(): [Map<number, string>, boolean] {
  const [specialties, setSpecialties] = React.useState<Map<number, string>>(
    new Map()
  );
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);
    axios
      .get<ISpecialty[]>("/specialties/")
      .then((response) => {
        setSpecialties(new Map(response.data.map((x) => [x.id, x.name])));
        setLoading(false);
      })
      .catch((error) => { console.error(error); setLoading(false); });
  }, []);

  return [specialties, loading];
}
